/**
 * The ticker bar's CURRENT visibility, banked per context (module-level, like
 * TickerBanner's marqueeResume / entrance flags).
 *
 * Parents that reserve space for the ticker (TableHeader's floating clusters,
 * Game's landscape action rail) REMOUNT on every table switch, and their
 * "is the ticker showing" state started at false and corrected in an effect.
 * That correction is not free: the cluster styles carry a `top` transition,
 * and the marquee's layout effect forces a style resolution between the mount
 * and the correction, so the browser sees a before/after pair and REPLAYS the
 * 0.3s slide on every swipe - the header elements visibly re-animating.
 * Seeding from the banked value makes a remounted header first-paint at its
 * settled position: no style change, no transition, no movement.
 *
 * Lives in its own module (not TickerBanner.tsx) so tests that mock the
 * TickerBanner component keep working, and so consumers don't have to import
 * the whole banner to read a boolean.
 */
const visibleByContext = new Map<string, boolean>();

export const getTickerVisible = (context: string): boolean => !!visibleByContext.get(context);

export const setTickerVisibleForContext = (context: string, visible: boolean): void => {
  visibleByContext.set(context, visible);
};

/** Test helper: forget everything (module state outlives a render). */
export const resetTickerVisibility = (): void => visibleByContext.clear();
